import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { ProposalRejectionOptionRole } from 'v2/models';
import { useProposalRejectionOptions } from 'v2/queries';
import styles from './buyerRejectProposalModal.module.scss';
import { RejectProposal } from './SearchResponseItem';

interface BuyerResponseModalProps {
  show: boolean;
  onHide: () => void;
  reject: RejectProposal;
  isBusy: boolean;
  providerName: string;
}

const BuyerResponseModal = ({
  show,
  onHide,
  reject,
  isBusy,
  providerName,
}: BuyerResponseModalProps) => {
  const [otherOptionId, setOtherOptionId] = useState<number>();
  const [selectedOptionId, setSelectedOptionId] = useState<number>();
  const [rejectText, setRejectText] = useState<string>();
  const { data: proposalRejectionOptions } = useProposalRejectionOptions({
    role: ProposalRejectionOptionRole.data_buyer,
    onSuccess: (proposalRejectionOptions) => {
      const otherOption = proposalRejectionOptions.find(
        (item) => item.text.toLowerCase() === 'other'
      );
      setOtherOptionId(otherOption?.id);
    },
  });

  const isSubmitDisabled = () =>
    (selectedOptionId === otherOptionId && !rejectText) ||
    !selectedOptionId ||
    isBusy;

  return (
    <Modal
      className={styles.root}
      size="lg"
      centered
      show={show}
      onHide={onHide}
      scrollable
    >
      <Modal.Header className="bg-light py-4">
        <Modal.Title>Provider Rejection</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Please let us know why the response from {providerName} isn’t a fit
          for your request
        </p>
        <Form.Group>
          <Form.Control
            as="select"
            placeholder="Select an Option"
            value={selectedOptionId || 0}
            onChange={(e) => setSelectedOptionId(Number(e.currentTarget.value))}
            aria-label="rejectDropDown"
          >
            <option value={0} disabled>
              Select an Option
            </option>
            {proposalRejectionOptions?.map((option) => (
              <option key={option.id} value={option.id}>
                {option.text}
              </option>
            ))}
          </Form.Control>
          {selectedOptionId && selectedOptionId === otherOptionId ? (
            <Form.Control
              className="mt-3"
              type="text"
              placeholder="Please enter a reason why the provider wasn't a fit for this request"
              autoComplete="off"
              value={rejectText}
              onChange={(e) => setRejectText(e.currentTarget.value)}
              aria-label="rejectReason"
              isInvalid={!rejectText}
            />
          ) : null}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={isSubmitDisabled()}
          onClick={() => {
            if (selectedOptionId) {
              reject(selectedOptionId, rejectText);
            }
          }}
        >
          {isBusy ? 'Loading...' : 'Submit'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BuyerResponseModal;
